import ThemeVideoModalController from '../../video-modals.js';
import { ThemeHomeVideoManager } from '../../home-video.js';
import HomeFormController from '../../home/form.js';
import LazyMediaController from '../../lazyLoadImagesN.js';
import CustomerImageController from '../../category.js';
import CustomUiController from '../../custom.js';
import DoctorProfileModalController from '../../page-doi-ngu-bs/profile-bs-modal.js';
import HospitalIntroductionController from '../../gioi-thieu-benh-vien.js';
import SingleServiceController from '../../single-service-sale.js';

import AboutHospitalCarouselController from '../../gioi-thieu-benh-vien/about-hospital-carousel.js';
import SpecialPostPopupController from '../../single/special-post-popup.js';

import DynamicImportModule from './dynamic-import-module.js';

export function createThemeModules(context) {
	return [
		new DynamicImportModule('floating-contact', () => import('../../contact-social.js')),

		new CustomUiController(),
		new ThemeVideoModalController(),
		new ThemeHomeVideoManager(),
		new HomeFormController(),
		new LazyMediaController(),
		new CustomerImageController(),
		new DoctorProfileModalController(),
		new HospitalIntroductionController(),
		new AboutHospitalCarouselController(context.$),
		new SingleServiceController(),
		new SpecialPostPopupController(),
	];
}
